import { defineVuePlugin } from '#/vue-plugins'

import { useSessionTracking } from '@/shared/lib'

export default defineVuePlugin((app) => {
  app.mixin({
    mounted() {
      // Only run once at the root level
      if (this.$root === this) {
        const { endSession } = useSessionTracking()

        if (typeof window !== 'undefined') {
          window.addEventListener('beforeunload', () => {
            endSession()
          })

          document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'hidden') {
              endSession()
            }
          })
        }
      }
    },
  })
})
